import { render, staticRenderFns } from "./IconFontBadge.vue?vue&type=template&id=882fcb2e"
import script from "./IconFontBadge.vue?vue&type=script&lang=js"
export * from "./IconFontBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports